"use strict";

var authActions = _interopRequireWildcard(require("./auth"));

var queryActions = _interopRequireWildcard(require("./query"));

var storageActions = _interopRequireWildcard(require("./storage"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.storageActions = exports.queryActions = exports.authActions = exports.default = void 0;
exports.authActions = authActions;
exports.queryActions = queryActions;
exports.storageActions = storageActions;

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) return obj;
  var newObj = {};
  if (null != obj) for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
      desc.get || desc.set ? Object.defineProperty(newObj, key, desc) : newObj[key] = obj[key];
    }
  }
  return newObj.default = obj, newObj;
}

var _default = {
  authActions: authActions,
  queryActions: queryActions,
  storageActions: storageActions
};
exports.default = _default;